(function () {
  'use strict';

  function parseStatValue(text) {
    var prefix = '';
    var suffix = '';
    var number = 0;

    var match = text.match(/^([+\-]?)(\d+(?:\.\d+)?)(.*)/);
    if (match) {
      prefix = match[1];
      number = parseFloat(match[2]);
      suffix = match[3];
    }
    return { prefix: prefix, number: number, suffix: suffix };
  }

  function animateCountUp(element, duration) {
    var raw = element.getAttribute('data-count');
    if (!raw) return;

    var parsed = parseStatValue(raw.trim());
    if (parsed.number === 0) return;

    var startTime = null;
    var isFloat = raw.indexOf('.') !== -1;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      // easeOutCubic
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = eased * parsed.number;

      if (isFloat) {
        element.textContent = parsed.prefix + current.toFixed(1) + parsed.suffix;
      } else {
        element.textContent = parsed.prefix + Math.floor(current) + parsed.suffix;
      }

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        element.textContent = raw.trim();
      }
    }

    requestAnimationFrame(step);
  }

  function initCountUp() {
    var containers = document.querySelectorAll('.mod-stats-card');
    if (!containers.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var numbers = entry.target.querySelectorAll('.mod-stats-card__number[data-count]');
            numbers.forEach(function (el) {
              if (!el.classList.contains('is-counted')) {
                el.classList.add('is-counted');
                animateCountUp(el, 2000);
              }
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    containers.forEach(function (container) {
      observer.observe(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountUp);
  } else {
    initCountUp();
  }
})();
